# data:[<MIME-type>][;charset=<encoding>][;base64],<data>
module.exports = (uri) ->
  [header, base64] = uri.split(',')

  parsedHeader = ///
    data:
    ([^;]+)                 # MIME-type
    (?:;charset=([^;]*))?   # encoding
    (;base64)?              #
  ///.exec(header)

  if parsedHeader?
    [all, mimeType, encoding, isBase64] = parsedHeader
    if !isBase64
      throw Error("Unable to handle non-base64 URIs")
    if encoding?
      throw Error("Unable to handle encodings")

    binary = atob(base64)

    array = (c.charCodeAt(0) for c in binary)

    new Blob([new Uint8Array(array)], { type: mimeType })

  else
    throw Error('Invalid data URI')
